/**
 * Returns true when the value is either empty (phone is optional)
 * or contains a plausible phone number:
 *  - only +, digits, spaces, dashes, dots, parentheses
 *  - between 7 and 15 actual digits (E.164 max)
 */
export default function validatePhone(value: string): boolean {
    const trimmed = value.trim();
    if (!trimmed) return true;
    const digits = trimmed.replace(/\D/g, '');
    return /^[+\d\s\-().]+$/.test(trimmed) && digits.length >= 7 && digits.length <= 15;
}
